module.exports = __webpack_public_path__ + "static/media/scratchcard_foreground.1de506f2.jpg";